export default __webpack_public_path__ + "static/media/wage.b95a4a9c.png";